import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../Axios/index';

// Async Thunks for API Calls
export const sendOtp = createAsyncThunk('otp/sendOtp', async (email, { rejectWithValue }) => {
  try {
    const response = await axios.post('/otp/send-otp', { email });
    return response.data.message;
  } catch (error) {
    return rejectWithValue(error.response?.data?.error || 'Failed to send OTP');
  }
});

export const verifyOtp = createAsyncThunk(
    'otp/verifyOtp',
    async ({ email, otp }, { rejectWithValue }) => {
      try {
        const response = await axios.post('/otp/verify-otp', { email, otp });
        console.log(response)
  
        console.log('Server Response:', response.status, response.data);
  
        // Explicitly handle failed cases (non-200 responses)
        if (response.status !== 200) {
          throw new Error(response.data.error || 'OTP verification failed'); 
        }
  
        return response.data.message;  // Success case
      } catch (error) {
        console.log('Error Occurred:', error);
  
        return rejectWithValue(error.response?.data?.error || 'OTP verification failed');
      }
    }
  );

const otpSlice = createSlice({
  name: 'otp',
  initialState: {
    loading: false,
    otpSent: false,
    verified: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
        state.error = null; // Clear error manually
      },
      resetOtp: (state) => {
        state.error = null; 
        state.verified = false; 
        state.loading = false; 
        state.otpSent= false

      },
  },
  extraReducers: (builder) => {
    builder
      // Handle Send OTP
      .addCase(sendOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendOtp.fulfilled, (state) => {
        state.loading = false;
        state.otpSent = true;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle Verify OTP
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state) => {
        state.loading = false;
        state.verified = true;
        console.log("in success")
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        console.log("In rejection")
        state.error = action.payload;
      });
  },
});

export const { resetOtpState  , clearError , resetOtp} = otpSlice.actions;
export default otpSlice.reducer;
